export const PrintingStatusTypeArray = ['READY', 'ON', 'COMPLETE', 'FAILED'] as const;
export type PrintingStatusType = typeof PrintingStatusTypeArray[number];

export const PrintingStatusTypeLabel: Record<PrintingStatusType, string> = {
	READY: '출력 대기',
	ON: '출력 중',
	COMPLETE: '출력 완료',
	FAILED: '출력 실패',
};
